import { Component, Input, OnChanges } from '@angular/core';
import { ReportingsCollection } from '../../interfaces/new-reporting-filter';

@Component({
  selector: 'avs-reporting-container',
  standalone: false,
  templateUrl: './reporting-container.component.html',
  styleUrl: './reporting-container.component.css'
})
export class ReportingContainerComponent implements OnChanges {

  @Input() reportCollection: ReportingsCollection[] = [];
  @Input() selectedIndex: number = -1;

  
  selectedReport: ReportingsCollection | null = (this.selectedIndex > -1 && this.selectedIndex < this.reportCollection.length) ? this.reportCollection[this.selectedIndex]: null;
  collectionLength : number = this.reportCollection.length;

  public ngOnChanges(): void {
    if (this.collectionLength < this.reportCollection.length) {
      this.selectedReport = (this.selectedIndex > -1 && this.selectedIndex < this.reportCollection.length) ? this.reportCollection[this.selectedIndex]: null;
    }
    this.collectionLength = this.reportCollection.length;
  }
  public removeSelectedReport(): void {
    var selected = this.reportCollection.findIndex(item => item == this.selectedReport);
    if (selected > -1) {
      this.reportCollection.splice(selected, 1);
      this.collectionLength = this.reportCollection.length;
      if (selected >= this.collectionLength)
        selected -= 1;
      this.selectedReport = (selected < this.reportCollection.length) ? this.reportCollection[selected]: null;
    }
    else
      console.warn("Cannot determine index for report to delete from collection!");
  }
}
